import React, { useEffect, useState } from 'react';
import { getAllCustomers, updateQuery } from '../actions/customer.actions';
import { CustomerList } from './customerList';
import CustomerOrdersDialog from './customerOrdersDialog';
import { useAppSelector } from '../../../redux';
import { CUSTOMER_STORE_NAME } from '../../../contants/stores';
import { useLocation } from "react-router-dom";

const CustomerPage = () => {
  const location = useLocation();
  const customers = useAppSelector((state: any) => state[CUSTOMER_STORE_NAME].customers);
  const [showOrdersDialog, setShowOrdersDialog] = useState(false);
  const [selectedCustomerForOrders, setSelectedCustomerForOrders] = useState(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const offset = (currentPage - 1) * rowsPerPage;
    getAllCustomers(rowsPerPage, offset);
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    // Clear search input when location changes
    updateQuery('');
  }, [location.pathname]);

  return (
    <div className="shadow-md sm:rounded-lg flex flex-col items-center py-4 bg-white m-4 p-4">
      <CustomerList
        customers={customers}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        onPressItem={async (customer: any, formAction: string) => {
          if (formAction === 'VIEW_ORDERS') {
            setSelectedCustomerForOrders(customer);
            setShowOrdersDialog(true);
          }
        }}
      />
      {showOrdersDialog && selectedCustomerForOrders ? (
        <CustomerOrdersDialog 
          customer={selectedCustomerForOrders} 
          onClose={() => {
            setShowOrdersDialog(false);
            setSelectedCustomerForOrders(undefined);
          }} 
        />
      ) : null}
    </div>
  );
}

export default CustomerPage; 